/**
 * ERP & Treuhandbüro Data Portability / Connector Module (`web/src/lib/format.ts`).
 *
 * @statutory OR Art. 957a Abs. 2 Ziff. 1–5 (Vollständige & nachprüfbare Buchführung) · GeBüV Art. 6–10 (Datenübernahme & Prüfspur) · MWSTG Art. 70 · Schweizer Kontenrahmen KMU
 */
/** Swiss formatting: CHF 1’234.50, 26.09.2026. Amounts arrive as integer Rappen. */
export function chf(rappen: number | null | undefined, opts: { sign?: boolean; currency?: boolean; blankZero?: boolean } = {}) {
  if (rappen == null) return '—';
  if (opts.blankZero && rappen === 0) return '—';
  const neg = rappen < 0;
  const abs = Math.abs(Math.round(rappen));
  const int = Math.floor(abs / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '’');
  const s = `${int}.${String(abs % 100).padStart(2, '0')}`;
  const signed = neg ? `−${s}` : opts.sign && rappen > 0 ? `+${s}` : s;
  return opts.currency === false ? signed : `CHF ${signed}`;
}
export const amt = (r: number | null | undefined, blankZero = true) => chf(r, { currency: false, blankZero });
export const date = (iso?: string | null) => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}` : '—');
import { getLang } from './i18n';

export const dateTime = (iso?: string | null) => (iso ? new Date(iso).toLocaleString(getLang() === 'en' ? 'en-CH' : 'de-CH', { dateStyle: 'medium', timeStyle: 'short' }) : '—');
export const pct = (x: number) => `${Math.round(x * 100)} %`;
export const monthName = (m: string) => new Date(`${m}-01T00:00:00`).toLocaleString(getLang() === 'en' ? 'en-CH' : 'de-CH', { month: 'short' });
/**
 * "1’234.55" → 123455 Rappen, read as exact decimal text (no float multiplication, as money.ts toRappen on the server):
 * more than two decimals round half away from zero on the exact value ("1.005" → 101). Empty input is 0, anything
 * else that is not an amount is NaN.
 */
export const toRappen = (s: string) => {
  const t = String(s).replace(/['’\s]/g, '').replace(',', '.');
  if (t === '') return 0;
  const m = /^([+-]?)(\d*)(?:\.(\d*))?$/.exec(t);
  if (!m || (!m[2] && !m[3])) return NaN;
  const frac = m[3] ?? '';
  let r = Number(m[2] || '0') * 100 + Number(`${frac}00`.slice(0, 2));
  if (frac.length > 2 && frac[2] >= '5') r += 1;
  if (!Number.isSafeInteger(r)) return NaN;
  return m[1] === '-' && r !== 0 ? -r : r;
};
export const relTime = (iso: string) => {
  const d = (Date.now() - new Date(iso).getTime()) / 1000;
  const en = getLang() === 'en';
  if (d < 60) return en ? 'just now' : 'gerade eben';
  if (d < 3600) return en ? `${Math.floor(d / 60)} min ago` : `vor ${Math.floor(d / 60)} Min.`;
  if (d < 86400) return en ? `${Math.floor(d / 3600)} h ago` : `vor ${Math.floor(d / 3600)} Std.`;
  return date(iso.slice(0, 10));
};

